"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPORT_THIEME_DOMAIN = exports.languages = void 0;
/**
 * CONSTANTS
 */
var SPORT_THIEME_DOMAIN = "sport-thieme.io";
exports.SPORT_THIEME_DOMAIN = SPORT_THIEME_DOMAIN;
/**
 * CONFIGURATIONS
 */
var configurations = {
    production: {
        Auth: {
            region: "eu-west-1",
            identityPoolId: "eu-west-1:e1ec793e-7035-4a60-8856-a657ba0bd433",
            userPoolId: "eu-west-1_LZOe5YqJH",
            userPoolWebClientId: "7jueu39gqv5e5re8u54334d1k3",
            oauth: {
                domain: "sport-thieme-signin.auth.eu-west-1.amazoncognito.com",
                scope: ["email", "openid", "aws.cognito.signin.user.admin"],
                redirectSignIn: "https://" + SPORT_THIEME_DOMAIN,
                redirectSignOut: "https://" + SPORT_THIEME_DOMAIN,
                responseType: "code", // code, token
            },
            cookieStorage: {
                domain: "." + SPORT_THIEME_DOMAIN,
                expires: 1,
                secure: true,
            },
        },
        Analytics: {
            disabled: true,
        },
        Custom: {
            singleSignOnProviderId: "ST-AzureAD",
        },
    },
    development: {
        Auth: {
            region: "eu-west-1",
            identityPoolId: "eu-west-1:e1ec793e-7035-4a60-8856-a657ba0bd433",
            userPoolId: "eu-west-1_LZOe5YqJH",
            userPoolWebClientId: "5r0jrvt3783j7adnk6l39qjbrv",
            oauth: {
                domain: "sport-thieme-signin.auth.eu-west-1.amazoncognito.com",
                scope: ["email", "openid", "aws.cognito.signin.user.admin"],
                redirectSignIn: "http://localhost:3000",
                redirectSignOut: "http://localhost:3000",
                responseType: "code", // code, token
            },
            cookieStorage: {
                domain: "localhost",
                secure: false,
            },
        },
        Analytics: {
            disabled: true,
        },
    },
};
/**
 * LANGUAGES
 */
var DE = {
    singleSignOn: "Single Sign On",
    signIn: "Anmelden",
    signInWithOffice: "Anmelden mit Office365",
    signInWithUsername: "Anmelden mit Username",
    or: "oder",
};
var languages = {
    de: DE,
};
exports.languages = languages;
/**
 * EXPORTS
 */
var awsExportsOverride = process.env.REACT_APP_AUTH_LOCAL
    ? "development"
    : process.env.NODE_ENV === "production"
        ? "production"
        : "development";
var awsExports = configurations[awsExportsOverride || "development"];
exports.default = awsExports;
//# sourceMappingURL=aws-exports.js.map